import React from 'react';
import {
    BarChart,
    ClipboardList,
    LifeBuoy,
    DollarSign,
    FileText,
    Shield,
    Umbrella,
    Search,
    MessageCircle,
    Building,
    ClipboardCheck,
    Wrench,
    Server,
    FileCode,
    Settings,
    Target,
    Compass,
    Home,
    Layout,
    User,
    LucideIcon
} from 'lucide-react';

// Maps icon name strings to Lucide icon components
export const IconMap: Record<string, LucideIcon> = {
    'BarChart': BarChart,
    'ClipboardList': ClipboardList,
    'LifeBuoy': LifeBuoy,
    'DollarSign': DollarSign,
    'FileText': FileText,
    'Shield': Shield,
    'Umbrella': Umbrella,
    'Search': Search,
    'MessageCircle': MessageCircle,
    'Building': Building,
    'ClipboardCheck': ClipboardCheck,
    'Tool': Wrench,
    'Wrench': Wrench,
    'Server': Server,
    'FileCode': FileCode,
    'Settings': Settings,
    'Target': Target,
    'Compass': Compass,
    'Home': Home,
    'Layout': Layout,
    // Add more mappings as needed
};

// Component to render a Lucide icon by name
interface LucideIconProps {
    name: string;
    className?: string;
    size?: number;
}

export const LucideIconByName: React.FC<LucideIconProps> = ({
    name,
    className,
    size = 24
}) => {
    const IconComponent = IconMap[name] || User; // Default to User icon if not found

    return <IconComponent className={className} size={size} />;
}; 